export { default } from './resource-dialog.jsx';